import { render } from "./AppLightIcon.vue?vue&type=template&id=2f656178"
const script = {}

import exportComponent from "/Users/kamoliddin/Documents/iWork/Valvoline/promo2025/promo2025.lubricoil.uz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__